<template>
    <div class="audio-element"></div>
</template>
<script>
    export default {
        data() {
            return {
                fileId:null,
                fileUrl:null,
                currentFile:null,
                initialized:false,
                audioElement:null,
                currentTime:0,
                isPlaying:false,
                percentagePlayed: 0,
                description: ''
            };
        },
        methods: {
            start() {
                this.audioElement.play();
                this.isPlaying = true;

                this.$root.$emit('audioElementStarts', {
                    fileId:this.fileId,
                    fileUrl:this.fileUrl,
                });

                axios.post('/vue/increment-play-counter', {
                    uniqid: this.fileId
                })
                .then(response => {
                })
                .catch(() => {});
            },
            stop() {
                this.isPlaying = false;
                this.audioElement.pause();

                this.$root.$emit('audioElementStops', {
                    fileId:this.fileId,
                    fileUrl:this.fileUrl,
                });
            },
            seek(seconds) {
                this.audioElement.currentTime = seconds;
                this.start();
            },
            reset() {
                this.audioElement.currentTime = 0;
                this.currentTime = 0;
                this.percentagePlayed = 0;
                this.stop();

                this.$root.$emit('audioElementResets', {
                });
            },
            timeUpdate(seconds) {
                this.currentTime = seconds;

                const percentage = (this.currentTime / this.audioElement.duration) * 100;
                let sendPercentage = false;

                if (percentage >= 25 && this.percentagePlayed < 25) {
                    this.percentagePlayed = 25;
                    sendPercentage = 25;
                } else if (percentage >= 50 && this.percentagePlayed < 50) {
                    this.percentagePlayed = 50;
                    sendPercentage = 50;
                } else if (percentage >= 75 && this.percentagePlayed < 75) {
                    this.percentagePlayed = 75;
                    sendPercentage = 75;
                } else if (percentage >= 100 && this.percentagePlayed < 100) {
                    this.percentagePlayed = 100;
                    sendPercentage = 100;
                }

                if (sendPercentage) {
                    _gte('audio', {
                        'event_category': document.title,
                        'event_label': sendPercentage + '% - ' + this.description,
                    });
                }

                this.$root.$emit('audioElementTimeUpdate', {
                    fileId:this.fileId,
                    fileUrl:this.fileUrl,
                    seconds:this.currentTime,
                });
            },
        },
        mounted() {
            var vm = this;

            this.audioElement = new Audio();
            this.audioElement.addEventListener('timeupdate', function() {
                vm.timeUpdate(this.currentTime);
            });
            this.audioElement.addEventListener('ended', function() {
                vm.reset();
            });

            // users clicks on a PlayButton
            this.$root.$on('togglePlayButton',data => {
                this.fileId = data.fileId;
                this.fileUrl = data.fileUrl;
                this.description = data.description;
                var requestedFile = this.fileId ? '/files/audio/'+this.fileId+'.m4a' : this.fileUrl;
                if (requestedFile != this.currentFile) {
                    this.currentFile = requestedFile;
                    this.audioElement.src = this.currentFile;
                    this.reset();
                    this.start();

                    _gte('play', {
                        'event_category': document.title,
                        'event_label':  this.description
                    });
                } else {
                    if (this.isPlaying) {
                        this.stop();

                        _gte('stop', {
                            'event_category': document.title,
                            'event_label':  this.description
                        });
                    } else {
                        this.start();

                        _gte('play', {
                            'event_category': document.title,
                            'event_label':  this.description
                        });
                    }
                }
            })

            // user clicks on a waveform
            this.$root.$on('clickWaveform',data => {
                this.fileId = data.fileId;
                this.fileUrl = data.fileUrl;
                var requestedFile = this.fileId ? '/files/audio/'+this.fileId+'.m4a' : this.fileUrl;
                if (requestedFile != this.currentFile) {
                    this.currentFile = requestedFile;
                    this.audioElement.src = this.currentFile;
                    this.reset();
                }
                this.seek(data.seconds);
                this.start();
            })

            this.$root.$on('filterAction', data => {
                this.reset();
            });

            this.$root.$on('audioElementStop',data => {
                this.stop();
            })

            this.$root.$on('audioElementReset',data => {
                this.reset();
            })

        },
    }
</script>
